import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";

import {
  changeNewsActiveAdminServices,
  createNewsAdminService,
  deleteNewsAdminServices,
  editNewsAdminServices,
  getNewsAdminService,
} from "../../../services/userServices";

export const newsAdminContext = createContext({
  isOpenAddModal: null,
  setIsOpenAddModal: () => {},
  getNewsItems: [],
  setGetNewsItems: () => {},
  newsId: "",
  setNewsId: () => {},
  adminUser: "",
  setAdminUser: () => {},
  status: [],
  setStatus: () => {},
  handleCreateNewsAdmin: () => {},
  handleGetNewsAdmin: () => {},
  handleEditNewsAdmin: () => {},
  handleCloseEditModal: () => {},
  handleOpenEditModal: () => {},
  handleChangeActivationNews: () => {},
  handleDeleteNews: () => {},
});

const NewsAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [getNewsItems, setGetNewsItems] = useState([]);
  const [newsId, setNewsId] = useState("");
  const [adminUser, setAdminUser] = useState("");

  //* Handle Create News Admin
  const handleCreateNewsAdmin = async (userData) => {
    const objData = {
      ...userData,
      adminUser: Number(userData.adminUser),
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createNewsAdminService(objData);
      if (status === 200) {
        setIsOpenAddModal(false);
        handleGetNewsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Get News Admin
  const handleGetNewsAdmin = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getNewsAdminService();
      if (status === 200) {
        setGetNewsItems(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //! Start Edit
  //* Handle Edit News Admin
  const handleOpenEditModal = (_item, setValue) => {
    setNewsId(_item.id);

    setValue("id", _item.id);
    setValue("title", _item.title);
    setValue("description", _item.description);
    setValue("isShow", _item.isShow);
  };

  const handleCloseEditModal = () => {
    setNewsId("");
  };

  const handleEditNewsAdmin = async (userData) => {
    const objData = {
      ...userData,
      adminUser: Number(userData.adminUser),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editNewsAdminServices(objData);
      if (status === 200) {
        handleCloseEditModal();
        handleGetNewsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };
  //! End Edit

  //* Change Activation News
  const handleChangeActivationNews = async (id, isShow) => {
    const objData = {
      id,
      isShow,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeNewsActiveAdminServices(objData);
      if (status === 200) {
        handleGetNewsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Delete News Admin
  const handleDeleteNews = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteNewsAdminServices(id);
      if (status === 200) {
        handleGetNewsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <newsAdminContext.Provider
      value={{
        isOpenAddModal,
        setIsOpenAddModal,
        getNewsItems,
        setGetNewsItems,
        newsId,
        setNewsId,
        adminUser,
        setAdminUser,
        handleCreateNewsAdmin,
        handleGetNewsAdmin,
        handleEditNewsAdmin,
        handleCloseEditModal,
        handleOpenEditModal,
        handleChangeActivationNews,
        handleDeleteNews,
      }}
    >
      {children}
    </newsAdminContext.Provider>
  );
};

export default NewsAdminContext;
